<template>
    <div class="modal fade" id="tour_pay_modal" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog" style="width: 750px;">
            <div class="modal-content">
                <div class="modal-header" style="">银行转账流程</div>
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <p class="content-title">请汇款至以下账户：</p>
                    <p>账户名：皇家加勒比游轮船务（中国）有限公司</p>
                    <p>银行名：摩根大通银行（中国）有限公司上海分行</p>
                    <p>银行地址：中国上海市浦东新区银城中路501号上海中心48楼，200120</p>
<!--                    <p>银行地址：中国上海市静安区南京西路 1601 号越洋国际广场 41 楼, 200040</p>-->
                    <p>（直客）人民币账号：5002032000</p>
                    <div class="offline-pay-flow">
                        <div class="offline-pay-item item-height">
                            <p style="position: relative;top: 10px;">支付方式为银行转账/汇款</p>
                        </div>
                        <div class="down-arrow">
                            <img src="https://resource.rcclchina.com.cn/tui2/order/down_arrow_yellow.png">
                        </div>

                        <div class="offline-pay-item item-height">

                            <p style="position: relative;top: 10px;">请务必备注好您的订单号、姓名</p>
                        </div>
                        <div class="down-arrow">
                            <img src="https://resource.rcclchina.com.cn/tui2/order/down_arrow_yellow.png">
                        </div>

                        <div class="offline-pay-item item-height">
                            <p>银行转账/汇款成功并与客服确认</p>
                            <p>请务必在完成付款后致电400-820-7195与客服确认</p>
                        </div>
                    </div>
                    <div style="margin-top: 22px;">特别提醒：
                        <p>1.若您预订的房型为特定主题房（如巧虎主题房），请您通过线上渠道进行订单支付。线下转账需人工入账且时间较长，会导致您的订单没有及时入账而被系统自动取消。
                            <br>2.若公司转账，退款时需提供所需的公司证明及多份英文材料，退款周期较长，敬请谅解。</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BankPopup",
    props: {
        isShow: {
            type: Boolean
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {

        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
 .modal-header {
    border: 0;
    margin-left: 30px;
    font-size: 22px;
    color: #282b2c;
    font-weight: bold;
    padding: 0;
    padding-top: 30px;
}
.modal-body {
    padding: 15px 30px 30px 30px;
    font-size: 14px;
    color: #282b2c;
    p.content-title {
        font-size: 16px;
    }
    .offline-pay-flow {
        text-align: center;
        color: white;
        margin-top: 15px;
        .offline-pay-item {
            background: #54a3de;
            padding: 7px 0px;
            p {
                margin-bottom: 1px;
            }
        }
        .item-height {
            height: 56px;
        }

    }
    .down-arrow {
        margin: 5px auto;
    }
}
</style>
